import { render, staticRenderFns } from "./InvestmentDetails.vue?vue&type=template&id=0700d804&scoped=true&"
import script from "./InvestmentDetails.vue?vue&type=script&lang=js&"
export * from "./InvestmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentDetails.vue?vue&type=style&index=0&id=0700d804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0700d804",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VProgressCircular,VRow})
